import React from 'react';

import Box from '../Box'
import { Wrapper } from "./ACommonStyles";
import { getPcsUrls } from "./AHelpers";
import { useWindowWidth } from '../../../helpers';

import { styled } from "../../../stitches.config";
import BHotNewsBar from "./BHotNewsBar";


export default props => {
    const blockSettings = props.settings.settings;
    const pcs = getPcsUrls(blockSettings?.pcs_background_mobile, blockSettings?.pcs_background_desktop);
    //const hasPcs = (blockSettings?.pcs_background_mobile?.length > 0 || blockSettings?.pcs_background_desktop?.length > 0);
    const windowWidth = useWindowWidth();

    const w = window.innerWidth;

    const imageHeight =
        props.imageHeight ??
        (w >= 1310
            ? 716
            : w >= 996
                ? 533
                : undefined);

    // redakcja chciała cały blok jako jedna rzecz w kompozycji, dlatego zostaje taki układ

    return (
        <Root className="block--b-hot-news-super">
            <section className={props.blockGroupHasBackground ? "container container-with-background" : "container"}>

                {/* przekazywany komponent hot news bar  */}

                <BHotNewsBar settings={props.settings} blockSettings={{ tb_region: blockSettings?.tb_region }} />

                {/* pozycjonowanie bloku: TextOnPicture */}
                <div data-tb-region={props.blockSettings.tb_region}>
                    <Wrapper className="row" pcs={pcs}>
                        <div className="col-xs-12">
                            <Box {...props}
                                id="b6"
                                type={windowWidth > 996 ? "BTextOnPicture" : "BPhotoOnTop"}
                                settings={props.settings.b6}
                                imageHeight={(window.innerWidth > 995 ? imageHeight : 480)}
                                size="lg"
                                classes="" />
                        </div>
                    </Wrapper>

                    {/* pozycjonowanie bloków "czwórka" */}

                    <Wrapper className="row" pcs={pcs}>
                        <div className="col-xs-12 col-md-3">
                            <Box {...props}
                                id="b7"
                                type={windowWidth > 996 ? "BPhotoOnTop" : "BPhotoOnLeft"}
                                settings={props.settings.b7}
                                classes="" />
                        </div>
                        <div className="col-xs-12 col-md-3">
                            <Box {...props}
                                id="b8"
                                type={windowWidth > 996 ? "BPhotoOnTop" : "BPhotoOnLeft"}
                                settings={props.settings.b8}
                                classes="" />
                        </div>
                        <div className="col-xs-12 col-md-3">
                            <Box {...props}
                                id="b9"
                                type={windowWidth > 996 ? "BPhotoOnTop" : "BPhotoOnLeft"}
                                settings={props.settings.b9}
                                classes="" />
                        </div>
                        <div className="col-xs-12 col-md-3">
                            <Box {...props}
                                id="b10"
                                type={windowWidth > 996 ? "BPhotoOnTop" : "BPhotoOnLeft"}
                                settings={props.settings.b10}
                                classes="" />
                        </div>
                    </Wrapper>

                    {/* pozycjonowanie bloku "zobacz więcej" */}

                    <Wrapper className="row" pcs={pcs}>
                        <LinkSeeAll className={props.blockColorBackground === "#131212" ? "dark-background b-see-more-link" : "b-see-more-link"}>
                            <Box {...props} id="b11" type="BSeeMoreLink" settings={props.settings.b11} classes="" title="Zobacz wszystkie artykuły" />
                        </LinkSeeAll>
                    </Wrapper>
                </div>
            </section>
        </Root>
    );
}

const Root = styled("div", {
    position: "relative",
    marginTop: "32px",
    "@bp4": {
        marginTop: "24px",
    },

    // zmiana wysokości tytułu w textOnPicture
    "& .top-link-footer": {
        "@bp4": {
            paddingBottom: "24px",
            paddingLeft: "16px",
        }
    },

    // kolor linku
    "& .dark-background": {
        "& a": {
            color: "$aszdziennikPrimary !important"
        }
    },

    // specjalna zmiana coloru na background
    "& .container-with-background": {
        position: "relative",
        "& .photo-on-top": {
            backgroundColor: "transparent !important",
            "& .title": {
                color: "$grayscale0Fixed",
            },
        },
        "& .photo-on-left": {
            "& span": {
                color: "$grayscale0Fixed",
            },
        },

        "& .b-hot-news-bar": {
            position: "absolute",
            top: "-65px",
            left: 0,
            width: "calc(100% - 24px)",
            margin: "0 12px",
            "@bp4": {
                top: "-64px",
            },
        }
    },

    "& .b-hot-news-bar": {
        marginBottom: "12px",
        overflow: "hidden",
    },

    "& .b-hot-news-bar--blocked": {
        display: "none !important",
    }
});


const LinkSeeAll = styled("div", {
    textAlign: "center",
    textDecoration: "underline",
    fontWeight: "600",
    fontSize: "18px",
    lineHeight: "24px",
    color: "$grayscale0Fixed",
    marginTop: "48px",
});